import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { msalInstance } from "./store/msalInstance";

import { MsalProvider } from "@azure/msal-react";   // ✅ ADD

import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
       <GoogleOAuthProvider clientId="930751324690-o98j38la7jqobqikhkrlhvb28ghiomg5.apps.googleusercontent.com">
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </GoogleOAuthProvider>
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();
// my learn ssdntech com - 112436030346-qd1e0b1psvjhbst5jt6uaniegaqrqo5h.apps.googleusercontent.com
// 930751324690-o98j38la7jqobqikhkrlhvb28ghiomg5.apps.googleusercontent.com